function addPrefix(string, prefix = 'mu-') {
	const splice = (string, index, prefix) => string.slice(0, index) + prefix + string.slice(index);
	return string
		.split(' ')
		.map((c) => {
			if (c.indexOf(':') !== -1) {
				return splice(c, c.indexOf(':') + 1, prefix);
			}
			return prefix + c;
		})
		.join(' ');
}

module.exports = addPrefix;
